































































































































































































































































































import { defineComponent, ref, useContext, onMounted, useFetch, computed, onBeforeUnmount } from '@nuxtjs/composition-api';
import { useHomeBannerData } from '~/components/HomePage/homeBanner';
import SkeletonLoader from '~/components/SkeletonLoader/index.vue';
import { SfCarousel, SfLink, SfTabs } from '@storefront-ui/vue';
import { useCache, CacheTagPrefix } from '@vue-storefront/cache';
/* import { CmsPage } from '~/modules/GraphQL/types';
import { useContent } from '~/composables'; */
import { useNewGearItems } from '~/components/HomePage/newGearItem';
import { useSweetDeals } from "~/components/HomePage/sweetDeals";
import { useOpenBoxByCategory } from "~/components/HomePage/openBoxItem";
import { useFeaturedProductsByCategory } from '~/components/czar/homeFeaturedProducts/homeFeaturedProducts';
import customProductCard from '~/components/czar/customProductCard/customProductCard.vue';
import customProductCard1 from '~/components/czar/customProductCard/customProductCard1.vue';
import { storeToRefs } from 'pinia';
export default defineComponent({
  name: 'HomePage',
  components: {
    customProductCard,
    customProductCard1,
    SfTabs,
    SfCarousel,
    SfLink,
    SkeletonLoader
  },

  setup() {
    const homeBannerSection = useHomeBannerData();
    const { sliders } = storeToRefs(homeBannerSection);
    const { addTags } = useCache();
    /* const { loadPage } = useContent(); */
    const newGearItems = useNewGearItems();
    const { data } = storeToRefs(newGearItems);
    const sweetDealsItems = useSweetDeals();
    const { sweetDealsData } = storeToRefs(sweetDealsItems);
    const usedGearItems = useFeaturedProductsByCategory();
    var queryVariables = { category_id: "1207" };
    usedGearItems.fetchUsedGear(queryVariables);
    const { usedGearData } = storeToRefs(usedGearItems);
    const openBoxItems = useOpenBoxByCategory();
    var queryVariables = { category_id: "1259" };
    openBoxItems.fetchUsedGear(queryVariables);
    const { openBoxData } = storeToRefs(openBoxItems);
    var slider_loading = ref(true);
    const initFun = (info) => { 
      slider_loading.value = false;
      // Fix accessibility issue: manage tabindex for slider items
      if (process.client) {
        setTimeout(() => {
          const sliderContainer = info.container;
          const slides = sliderContainer.querySelectorAll('.tns-item');
          
          slides.forEach((slide, index) => {
            const links = slide.querySelectorAll('a, button, [tabindex]');
            const isActive = slide.classList.contains('tns-slide-active');
            
            links.forEach(link => {
              if (isActive) {
                // Active slide: make links focusable
                link.removeAttribute('tabindex');
                link.removeAttribute('aria-hidden');
              } else {
                // Hidden slides: make links non-focusable
                link.setAttribute('tabindex', '-1');
                link.setAttribute('aria-hidden', 'true');
              }
            });
          });
        }, 100);
      }
    }

    const handleSlideChange = (info) => {
      // Fix accessibility on slide change
      if (process.client) {
        setTimeout(() => {
          const sliderContainer = info.container;
          const slides = sliderContainer.querySelectorAll('.tns-item');
          
          slides.forEach((slide, index) => {
            const links = slide.querySelectorAll('a, button, [tabindex]');
            const isActive = slide.classList.contains('tns-slide-active');
            
            links.forEach(link => {
              if (isActive) {
                // Active slide: make links focusable
                link.removeAttribute('tabindex');
                link.removeAttribute('aria-hidden');
              } else {
                // Hidden slides: make links non-focusable
                link.setAttribute('tabindex', '-1');
                link.setAttribute('aria-hidden', 'true');
              }
            });
          });
        }, 50);
      }
    }

    const main_categories = [
      {
        "title": "Cameras",
        "url": "/photography/cameras-lenses/digital-cameras.html",
		    "image_url": "/homepage/mpex/camera.png",
        "custom_class": "Photography-image",
        "__typename": "mainCategories"
      },
      {
        "title": "Lenses",
        "url": "/photography/cameras-lenses/lenses.html",
		    "image_url": "/homepage/mpex/lenses.png",
        "custom_class": "lenses-image",
        "__typename": "mainCategories"
      },
      {
        "title": "Accessories",
        "url": "/photography/accessories.html",
		    "image_url": "/homepage/mpex/Accessories.png",
        "custom_class": "Photo-image",
        "__typename": "mainCategories"
      },
      {
        "title": "Lighting",
        "url": "/lighting",
		    "image_url": "/homepage/mpex/lights.png",
        "custom_class": "lighting-image",
        "__typename": "mainCategories"
      },
      {
        "title": "Used",
        "url": "/shop-used-gear",
		    "image_url": "/homepage/mpex/used.png",
        "custom_class": "Used-image",
        "__typename": "mainCategories"
      },
      {
        "title": "Audio",
        "url": "/audio",
		    "image_url": "/homepage/mpex/audio.png",
        "custom_class": "audio-image",
        "__typename": "mainCategories"
      },
      {
        "title": "Video",
        "url": "/video",
		    "image_url": "/homepage/mpex/videos.png",
        "custom_class": "Video-image",
        "__typename": "mainCategories"
      },
      {
        "title": "Film",
        "url": "/photography/film-darkroom-supplies/film.html",
		    "image_url": "/homepage/mpex/film.png",
        "custom_class": "film-image",
        "__typename": "mainCategories"
      },
      {
        "title": "Printers",
        "url": "/photography/scanning-printing/photo-printers.html",
		    "image_url": "/homepage/mpex/printers.png",
        "custom_class": "printer-image",
        "__typename": "mainCategories"
      },      
      {
        "title": "Student Kits",
        "url": "/photography/film-darkroom-supplies/student-kits.html",
		    "image_url": "/homepage/mpex/StudentKits.png",
        "custom_class": "student-kits",
        "__typename": "mainCategories"
      }
    ];

    /* const page = ref<CmsPage | null>(null);
    useFetch(async () => { page.value = await loadPage({ identifier: 'home' }); }); */

    useFetch(async () => {
      await homeBannerSection.load();
    });

    onMounted(() => { addTags([{ prefix: CacheTagPrefix.View, value: 'home' }]); });

    const screenWidth = ref(process.client ? window.innerWidth : 1640) // fallback SSR

    function updateScreenWidth() {
      screenWidth.value = window.innerWidth
    }

    onMounted(() => {
      updateScreenWidth()
      window.addEventListener('resize', updateScreenWidth)
    })

    onBeforeUnmount(() => {
      window.removeEventListener('resize', updateScreenWidth)
    })

    const activeTabChanged = (newActiveTab) => {
      const customAttribute = newActiveTab.title;      
      return customAttribute;
    };

    const loading = ref(false);
    const changeTab = (tabNumber: number) => {
      if (tabNumber == 1) {
        loading.value = true;
        if (process.client) {
          setTimeout(function(){
            loading.value = false;
            window.dispatchEvent(new Event('resize'));
          },0.5);
        }
      }
      if (tabNumber == 2) {
        loading.value = true;
        if (process.client) {
          setTimeout(function(){
            loading.value = false;
            window.dispatchEvent(new Event('resize'));
          },0.5);
        }
      }
      if (tabNumber == 3) {
        loading.value = true;
        if (process.client) {
          setTimeout(function(){
            loading.value = false;
            window.dispatchEvent(new Event('resize'));
          },0.5);
        }
      }
      if (tabNumber == 4) {
        loading.value = true;
        if (process.client) {
          setTimeout(function(){
            loading.value = false;
            window.dispatchEvent(new Event('resize'));
          },0.5);
        }
      }
      return tabNumber;
    };
    
    const customactivetab = ref(1);
    const activeTab = computed((tab) => {
      return customactivetab.value;
    });
    const tab_nav_clicked = (tab) => {
      customactivetab.value = tab;
    };

    const firstBannerUrl = computed(() => {
      try {
        return (
          sliders.value?.homeBannerSection?.[0]?.sliders?.[0]?.banners?.[0]?.image_url ||
          null
        );
      } catch {
        return null;
      }
    });

    return {
      customactivetab,
      tab_nav_clicked,
      activeTabChanged,
      changeTab,      
      activeTab,
      /* page, */
      main_categories,
      data,
      sweetDealsData,
      usedGearData,
      openBoxData,
      loading,
      sliders,
      slider_loading,
      initFun,
      handleSlideChange,
      screenWidth,
      firstBannerUrl
    };
  },
  head() {
    return {
      'title':'Midwest Photo - Capture. Inspire. Share.',
      link: this.firstBannerUrl
        ? (() => {
            // Preload the exact optimized URL Nuxt Image will render for LCP
            const optimizedHref = this.$img(this.firstBannerUrl as string, { width: Number(this.screenWidth) || 1350, format: 'webp' });

            return [
              {
                hid: 'first-image-preload',
                rel: 'preload',
                as: 'image',
                href: optimizedHref
              }
            ];
          })()
        : []
    };
  }
});
